import ErrorMessage from 'components/ErrorMessage'
import OButton from 'components/reusable/OButton'
import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import { validationRules } from 'utils/constants'
import AuthContext from '../context/AuthContext'
import Loader from '../layout/Loader'
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'

function Login () {
  const { t } = useTranslation()
  const [icon, setIcon] = useState(true)

  const navigate = useNavigate()
  let { loginUser, user } = useContext(AuthContext)
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({ mode: 'onBlur', shouldFocusError: true, defaultValues: {} })
  const [rememberMe, setRememberMe] = useState(
    localStorage.getItem('rememberMe') === 'true' ? true : false
  )

  const handleRememberMe = e => {
    localStorage.setItem('rememberMe', e.target.checked)
    setRememberMe(e.target.checked)
  }

  useEffect(() => {
    if (rememberMe) {
      reset({
        username: localStorage.getItem('username'),
        password: localStorage.getItem('password')
      })
    }
  }, [])

  const onSubmit = data => {
    if (rememberMe) {
      localStorage.setItem('username', data.username)
      localStorage.setItem('password', data.password)
    } else {
      localStorage.removeItem('username')
      localStorage.removeItem('password')
    }
    loginUser(data)
  }
  useEffect(() => {
    if (user !== null) {
      navigate('/dashboard')
    }
  }, [user])

  function changeIcon () {
    setIcon(!icon)
  }

  const preventSpace = e => {
    if (e?.which === 32) {
      e.preventDefault()
    }
  }

  return (
    <div className='login-page h-full'>
      <Loader />
      <div className='p-4'>
        <div className='login-form bg-white max-w-lg m-auto mt-10 sm:mt-16 md:mt-28 rounded-[20px]'>
          <form
            className='sm:py-12 sm:px-11 py-8 px-7'
            onSubmit={handleSubmit(onSubmit)}
            method='post'
          >
            <img src='./images/logo.png' alt='' className='m-auto py-2' style={{width: "10rem"}} />
            <h1 className='text-center text-[40px] font-bold'>
              {t('LOGIN_LETS_START')}!
            </h1>
            <h2 className='text-center text-lg text-[#A5A5A5] sm:mb-12 mb-6'>
              {t('LOGIN_ONLY_FEW_MINUTES')}
            </h2>
            <div className='relative z-0 mb-6 w-full group'>
              <input
                type='text'
                id='username'
                className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                placeholder=' '
                onKeyDown={e => preventSpace(e)}
                {...register('username', {
                  required: 'Please enter username.',
                  pattern: {
                    value: validationRules.username,
                    message: 'Username is required.'
                  },
                  validate: value => {
                    return !!value.trim() ? true : 'White spaces not allowed.'
                  }
                })}
              />

              <label
                htmlFor='username'
                className='peer-focus:font-normal absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
              >
                {t('LOGIN_USERNAME')}
                <span className='text-red-500'>*</span>
              </label>
              <ErrorMessage message={errors?.username?.message} />
            </div>
            <div className='relative z-0 mb-6 w-full group'>
              <input
                type={icon ? 'password' : 'text'}
                name='password'
                id='password'
                maxLength={15}
                className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-black dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                placeholder=' '
                autoComplete='new-password'
                {...register('password', {
                  required: 'Please enter password.',
                  validate: value => {
                    return !!value.trim() ? true : 'White spaces not allowed.'
                  },
                  pattern: {
                    value: validationRules.password,
                    message:
                      'Password must contain lowercase,uppercase characters, numbers, special character and must be 8 character long.'
                  }
                })}
              />
              <label
                htmlFor='password'
                className='peer-focus:font-normal absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
              >
                {t('O_PASSWORD')}
                <span className='text-red-500'>*</span>
              </label>
              {icon ? (
                <span
                  className='password_view cursor-pointer absolute top-[18px] right-[20px]'
                  onClick={() => changeIcon()}
                >
                  <AiFillEyeInvisible />
                </span>
              ) : (
                <span
                  className='password_view absolute top-[18px] right-[20px]'
                  onClick={() => changeIcon()}
                >
                  <AiFillEye />
                </span>
              )}
              <ErrorMessage message={errors?.password?.message} />
            </div>
            <div className='flex items-start mb-8'>
              <div className='flex items-center h-5'>
                <div>
                  <input
                    id='remember'
                    type='checkbox'
                    checked={rememberMe ? true : false}
                    className='w-4 h-4 bg-gray-50 rounded border border-[#DFDFDF]  focus:ring-3 focus:ring-[#DFDFDF] dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-[#DFDFDF] dark:ring-offset-gray-800'
                    onChange={e => handleRememberMe(e)}
                  />
                </div>
                <label
                  htmlFor='remember'
                  className='ml-2 text-sm text-black dark:text-gray-300'
                >
                  {t('LOGIN_REMEMBER_ME')}
                </label>
              </div>
              <Link
                to='/forgot-password'
                className='ml-auto text-[#6236FF] hover:text-[#9D36FF] hover:underline text-sm font-medium'
              >
                {t('LOGIN_FORGOT_PASSWORD')}?
              </Link>
            </div>
            <div className='text-center mt-8'>
              <OButton label={<>{t('LOGIN_LOGIN')}</>} type='submit' />
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login
